// extracted by mini-css-extract-plugin
export var loading = "WalletButton-module--loading--650fc";
export var loadingContainer = "WalletButton-module--loadingContainer--fbc34";
export var loadingText = "WalletButton-module--loadingText--328e8";
export var spinner = "WalletButton-module--spinner--a2ec3";
export var unsupportedText = "WalletButton-module--unsupportedText--92e92";
export var walletButton = "WalletButton-module--walletButton--c63d7";
export var walletImage = "WalletButton-module--walletImage--e9f92";